import { render, staticRenderFns } from "./XmlMessageList.vue?vue&type=template&id=746fc3a0"
import script from "./XmlMessageList.vue?vue&type=script&lang=js"
export * from "./XmlMessageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports